export default {"src":"/_next/static/media/success-form.c90a6c74.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};